import React, { FC } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Button, F0Icon } from '@factorialco/f0-react'
import { Input, Select } from '@factorialco/f0-react/dist/experimental'
import { CheckCircle, CrossedCircle, Delete, Handle } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { ElementOption } from 'modules/forms/lib/types'

type Props = {
  handleUpdateOption: (index: number, label: string) => void
  handleUpdateOptionCorrect: (index: number, isCorrect: boolean) => void
  handleRemoveOption: (index: number) => void
  option: ElementOption
  index: number
  hasCorrectAnswer: boolean
}

export const ChoiceElement: FC<Props> = ({
  handleUpdateOption,
  handleUpdateOptionCorrect,
  option,
  handleRemoveOption,
  index,
  hasCorrectAnswer,
}) => {
  return (
    <Box
      gap="s8"
      flexDirection="row"
      alignItems="center"
      style={{
        transition: 'opacity 0.2s ease, background-color 0.2s ease',
      }}
    >
      <Box flexDirection="row" width="full" gap="s8">
        <Box cursor="grab" paddingTop="s16">
          <F0Icon color="secondary" size="xs" icon={Handle} />
        </Box>
        <Box width="full">
          <Input
            label={i18n.t('forms.editor.options.label', { position: index + 1 })}
            hideLabel
            onChange={(value: string) => {
              handleUpdateOption(index, value)
            }}
            placeholder={i18n.t('forms.editor.options.option_placeholder', { position: index + 1 })}
            value={option.label}
            maxLength={255}
            hideMaxLength
          />
        </Box>
        {hasCorrectAnswer && (
          <Box alignSelf="flexEnd" width="s300">
            <Select
              label={i18n.t('forms.editor.options.is_correct')}
              hideLabel
              options={[
                {
                  label: i18n.t('forms.editor.options.incorrect'),
                  value: 'false',
                  icon: CrossedCircle,
                },
                { label: i18n.t('forms.editor.options.correct'), value: 'true', icon: CheckCircle },
              ]}
              value={option.isCorrect ? 'true' : 'false'}
              onChange={(value: string) => {
                handleUpdateOptionCorrect(index, value === 'true')
              }}
            />
          </Box>
        )}

        <F0Button
          icon={Delete}
          hideLabel
          variant="ghost"
          aria-label={i18n.t('forms.editor.options.delete')}
          onClick={() => handleRemoveOption(index)}
        />
      </Box>
    </Box>
  )
}
